import { Citation } from '#/api'
import { TrafoChatReferenceItem } from './TrafoChatReferenceItem'
import styles from './TrafoChatReferences.module.css'

type TrafoChatReferenceProps = {
  citations: Citation[]
  onTitleClick: (citation: Citation) => void
  onShowClick: (citation: Citation) => void
}

export const TrafoChatReferences = ({ citations, onTitleClick, onShowClick }: TrafoChatReferenceProps) => {
  return (
    <div className={styles.referencesContainer}>
      {citations.map(citation => {
        return (
          <TrafoChatReferenceItem
            key={citation.id}
            citation={citation}
            onShowClick={onShowClick}
            onTitleClick={onTitleClick}
          />
        )
      })}
    </div>
  )
}
